<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import getUA from '@utils/getUA'
import todayAxios from '@utils/global/todayAxiosGlobal'

const route = useRoute()

onMounted(() => {
  init()
})

// 采集指纹信息
const collectFingerprint = () => {
  const userAgent = navigator.userAgent
  const screenResolution = `${screen.width}x${screen.height}`
  const pixelRatio = window.devicePixelRatio
  const timezone = -new Date().getTimezoneOffset()
  const language = navigator.language
  const timestamp = Date.now()

  // 从user_agent中提取device_model和system_version
  const deviceModelMatch = userAgent.match(/\((.*?)\)/)
  const deviceInfo = deviceModelMatch ? deviceModelMatch[1] : ''
  const deviceModel = deviceInfo.split(';')[0]?.trim() || ''
  const systemVersion = deviceInfo.split(';')[1]?.trim() || ''

  // 从screen_resolution中解析出screen_width和screen_height
  const [screenWidth, screenHeight] = screenResolution.split('x').map(Number)

  // 将pixel_ratio转换为scale
  const scale = pixelRatio

  // 从language中提取主语言代码language_code
  const languageCode = language.split('-')[0]

  return {
    user_agent: userAgent,
    screen_resolution: screenResolution,
    pixel_ratio: pixelRatio,
    timezone: timezone.toString(),
    language: language,
    timestamp: timestamp,
    // 提取的字段
    device_model: deviceModel,
    system_version: systemVersion,
    screen_width: screenWidth,
    screen_height: screenHeight,
    scale: scale,
    language_code: languageCode
  }
}

// 解析referrer参数中的utm参数并发送归因数据
const parseAndSetUtmParams = async (referrer) => {
  if (!referrer) return

  try {
    // URL解码referrer参数
    const decodedReferrer = decodeURIComponent(referrer)

    // 解析查询参数
    const urlParams = new URLSearchParams(decodedReferrer)
    const utmParams = {}

    // 提取需要的utm参数
    const utmKeys = [
      'utm_source',
      'utm_campaign',
      'utm_medium',
      'utm_content',
      'utm_term',
      'utm_campaign_id'
    ]
    utmKeys.forEach((key) => {
      const value = urlParams.get(key)
      if (value) {
        utmParams[key] = value
      }
    })
    console.log('utmParams', utmParams)

    // 如果有utm参数，则发送归因数据请求
    if (Object.keys(utmParams).length > 0) {
      const fingerprint = collectFingerprint()
      const payload = {
        fingerprint: JSON.stringify(fingerprint),
        ...utmParams
      }

      try {
        await todayAxios.post('/next/app/user/web/attribution/save', payload)

        console.log('归因数据保存成功')
      } catch (error) {
        console.error('发送归因数据失败:', error)
      }
    }
  } catch (error) {
    console.error('解析referrer参数失败:', error)
  }
}

const init = async () => {
  let queryParams = ''
  console.log('ua', getUA())
  if (getUA().isIOS && route.query.ct) {
    queryParams = `ct=${route.query.ct}&pt=126093046&mt=8`
  }

  // iOS情况下解析referrer参数并设置用户属性
  if (getUA().isIOS && route.query.referrer) {
    // 等待归因数据保存完成
    await parseAndSetUtmParams(route.query.referrer)
  }

  if (getUA().isAndroid && route.query.referrer) {
    queryParams = `referrer=${encodeURIComponent(
      encodeURIComponent(route.query.referrer)
    )}`
  }

  switch (true) {
    case getUA().isIOS:
      window.location.href = `https://apps.apple.com/app/apple-store/id6446071834?${queryParams}`
      break
    case getUA().isAndroid:
      window.location.href = `https://play.google.com/store/apps/details?id=com.oceangalaxy.camera.new&${queryParams}`
      break
    default:
      window.location.href = 'https://timemark.com/'
      break
  }
}
</script>

<template>
  <div></div>
</template>

<style scoped lang="scss"></style>
